/* ORBA interest page forms -> Klaviyo client API (public key only; no private key on the page).
   Trade form  -> "ORBA Trade Inquiry" event only (no list, no marketing consent) -> internal alert flow to Karen + Ryan
   First Sip   -> list set in the "ORBA first sip form" section (ORBA First Sip)
   Every submission carries utm_*, referrer and landing URL captured on first page load. */
(function () {
  if (window.__orbaFormsInit) return;
  window.__orbaFormsInit = true;

  var REVISION = '2025-01-15';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function readAttribution() {
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem('orba_attr') || 'null'); } catch (e) {}
    var params = new URLSearchParams(window.location.search);
    var hasUtm = KEYS.some(function (k) { return params.get(k); });
    if (stored && !hasUtm) return stored;
    var attr = { landing_url: window.location.href, referrer: document.referrer || '' };
    KEYS.forEach(function (k) { attr[k] = params.get(k) || ''; });
    try { sessionStorage.setItem('orba_attr', JSON.stringify(attr)); } catch (e) {}
    return attr;
  }
  var ATTR = readAttribution();

  function post(path, company, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t); });
      return r;
    });
  }

  function val(f, name) { var el = f.elements[name]; return el ? String(el.value || '').trim() : ''; }

  function buildProfile(f, kind) {
    var email = val(f, 'email');
    var props = {
      orba_form: kind,
      orba_signup_at: new Date().toISOString(),
      orba_landing_url: ATTR.landing_url,
      orba_referrer: ATTR.referrer
    };
    KEYS.forEach(function (k) { props['orba_' + k] = ATTR[k]; });
    var attrs = { email: email, properties: props };
    if (kind === 'trade') {
      var name = val(f, 'name');
      var parts = name.split(/\s+/);
      attrs.first_name = parts.shift() || '';
      attrs.last_name = parts.join(' ');
      attrs.organization = val(f, 'company');
      props.orba_buyer_type = val(f, 'type');
      props.orba_company = val(f, 'company');
      props.orba_phone = val(f, 'phone');
      props.orba_heard_from = val(f, 'heard');
      props.orba_stores_or_dcs = val(f, 'reach');
      props.orba_notes = val(f, 'notes');
    } else {
      var zip = val(f, 'zip');
      if (zip) { attrs.location = { zip: zip }; props.orba_zip = zip; }
    }
    return attrs;
  }

  function submit(f) {
    var kind = f.getAttribute('data-form');
    var list = f.getAttribute('data-list');
    var company = f.getAttribute('data-company');
    var source = f.getAttribute('data-source') || 'ORBA page';
    var ok = f.querySelector('.ok'), err = f.querySelector('.err'), btn = f.querySelector('button[type=submit]');

    if (val(f, 'website')) { ok.style.display = 'block'; btn.disabled = true; return; } // bot trap

    var req = Array.prototype.slice.call(f.querySelectorAll('[required]'));
    req.forEach(function (i) { i.classList.remove('invalid'); });
    var bad = req.find(function (i) {
      var v = i.value.trim();
      return !v || (i.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v));
    });
    var zipEl = f.elements['zip'];
    if (!bad && zipEl && zipEl.value.trim() && !/^\d{5}$/.test(zipEl.value.trim())) bad = zipEl;
    if (bad) { bad.classList.add('invalid'); bad.focus(); return; }

    if (!list || !company) {
      err.style.display = 'block';
      if (window.console) console.warn('[ORBA] Klaviyo list ID or site ID missing on this section');
      return;
    }

    btn.disabled = true; err.style.display = 'none';
    var profile = buildProfile(f, kind);

    var done;
    if (kind === 'trade') {
      // Trade inquiries are NOT marketing signups: no list subscription, no email consent.
      // One "ORBA Trade Inquiry" event carries the lead to Karen's alert flow; profile details ride along.
      var props = JSON.parse(JSON.stringify(profile.properties || {}));
      props.source_label = source;
      done = post('events', company, {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'ORBA Trade Inquiry' } } },
            profile: { data: { type: 'profile', attributes: profile } }
          }
        }
      });
    } else {
    // First Sip: 1) write profile details (zip, attribution); 2) subscribe to the ORBA First Sip list.
    var profileCall = post('profiles', company, { data: { type: 'profile', attributes: profile } })
      .catch(function (e) { if (window.console) console.warn('[ORBA] profile write failed', e); });

    done = profileCall.then(function () {
      return post('subscriptions', company, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: profile.email } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      });
    });
    }
    done.then(function () {
      ok.style.display = 'block';
      Array.prototype.forEach.call(f.querySelectorAll('input,select,textarea'), function (el) { el.disabled = true; });
      try { if (window.gtag) window.gtag('event', 'generate_lead', { form_name: 'orba_' + kind }); } catch (e) {}
    }).catch(function (e) {
      if (window.console) console.warn('[ORBA] subscribe failed', e);
      err.style.display = 'block';
      btn.disabled = false;
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form.orba-form'), function (f) {
      if (f.__orba) return; f.__orba = true;
      f.addEventListener('submit', function (e) { e.preventDefault(); submit(f); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
